import { render, staticRenderFns } from "./ShowDisabilityData.vue?vue&type=template&id=09be5b28&scoped=true&"
import script from "./ShowDisabilityData.vue?vue&type=script&lang=js&"
export * from "./ShowDisabilityData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be5b28",
  null
  
)

export default component.exports